import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { Inquiry, InquiryListParams } from '~/features/inquiry/types/inquiry.type';

/**
 * 문의 목록 조회
 * @endpoint GET /admin/inquiries
 */
export function getInquiryListApi(params?: InquiryListParams) {
  return axiosInstance.get<PaginatedApiResponse<Inquiry>>('/admin/inquiries', { params });
}
